import React from "react";
import { useNavigate } from "react-router-dom";
import "./Categories.css";

import tomato from "./tomato.png";
import onion from "./onion.png";
import banana from "./banana.png";
import turmeric from "./turmeric.png";
import coco from "./coco.png";
import maize from "./maize.png";
import jowar from "./jowar.png";

const categories = [
  { name: "Tomato powder", img: tomato, bg: "#fddcdc", path: "/tomato-powder" },
  { name: "Onion powder", img: onion, bg: "#e6cce6", path: "/onion-powder" },
  { name: "Banana powder", img: banana, bg: "#f7edc3", path: "/banana-powder" },
  { name: "Turmeric powder", img: turmeric, bg: "#f9e1c0", path: "/turmeric-powder" },
  { name: "Coco powder", img: coco, bg: "#d9c9bc", path: "/coco-powder" },
  { name: "Maize", img: maize, bg: "#efe1b0", path: "/maize-powder" },
  { name: "Jowar", img: jowar, bg: "#e0d4c2", path: "/jowar-powder" },
];

export default function Categories() {
  const navigate = useNavigate();

  return (
    <div className="categories-container">
      <h2 className="categories-title">Categories</h2>
      <p className="categories-subtitle">
        Natural, high-quality powders tailored for industrial use across food,
        cosmetic, and pharmaceutical sectors
      </p>

      <div className="categories-grid">
        {categories.map((cat) => (
          <div
            key={cat.path}
            className="category-card"
            style={{ backgroundColor: cat.bg, cursor: "pointer" }}
            onClick={() => navigate(cat.path)}
          >
            <img src={cat.img} alt={cat.name} className="category-img" />
            <p className="category-name">{cat.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
